import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";

function EditUser() {
  const [wait, setWait] = useState(1000);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
    //minWidth: "1em",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [userData, setUserData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_users/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const userData = await response.json();
      setUserData(userData);
      setSelectedPrenom(userData?.detail_fx_user?.Identification?.["Prénom"]);
      setSelectedNom(userData?.detail_fx_user?.Identification?.["Nom"]);
      setSelectedEmail(userData?.detail_fx_user?.Identification?.Email);
      setSelectedIdentifiant(
        userData?.detail_fx_user?.Identification?.Identifiant
      );
      setSelectedActif(userData?.detail_fx_user?.Droits?.Actif);
      setSelectedRole(userData?.detail_fx_user?.Droits?.["Rôle"]);
      setSelectedBuilder(userData?.detail_fx_user?.Droits?.["Builder"]);
      setSelectedInvestisseur(
        userData?.detail_fx_user?.Droits?.["Investisseur"]
      );
      setSelectedPartenaire(userData?.detail_fx_user?.Droits?.["Partenaire"]);
    } catch (error) {
      console.error(error);
    }
  };

  /************************* Role *******************************/
  const [roleData, serRoleData] = useState({
    data: [],
  });
  const [selectedRole, setSelectedRole] = useState("");
  const handleRoleChange = (e) => {
    setSelectedRole(e);
  };
  const getRole = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_users/fx_roles`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          serRoleData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderRoleOptions = () => {
    return [
      {
        options: roleData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END  *******************************/
  const [InvestisseurData, setInvestisseurData] = useState({
    data: [],
  });

  const getInvestisseurs = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_users/investisseurs`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setInvestisseurData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestisseurOptions = () => {
    return [
      {
        options: InvestisseurData?.data?.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const [PartenaireData, setPartenaireData] = useState({
    data: [],
  });

  const getPartenaires = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/fx_users/partenaires?id=${
          selectedRole?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setPartenaireData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireOptions = () => {
    return [
      {
        options: PartenaireData?.data?.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Actif *******************************/
  const [selectedActif, setSelectedActif] = useState("");
  const handleActifChange = (e) => {
    setSelectedActif(e);
  };

  /*************************   END Actif  *******************************/

  const [selectedPrenom, setSelectedPrenom] = useState("");
  const [selectedNom, setSelectedNom] = useState("");
  const [selectedEmail, setSelectedEmail] = useState("");
  const [selectedPassword, setSelectedPassword] = useState("");
  const [selectedIdentifiant, setSelectedIdentifiant] = useState("");
  const [selectedInvestisseur, setSelectedInvestisseur] = useState(null);
  const [selectedPartenaire, setSelectedPartenaire] = useState(null);
  const [selectedBuilder, setSelectedBuilder] = useState("");

  const handleInvestisseurChange = (e) => {
    setSelectedInvestisseur(e);
  };
  const handlePartenaireChange = (e) => {
    setSelectedPartenaire(e);
  };
  const handlePrenomChange = (e) => {
    setSelectedPrenom(e.target.value);
  };

  const handleNomChange = (e) => {
    setSelectedNom(e.target.value);
  };

  const handleEmailChange = (e) => {
    setSelectedEmail(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setSelectedPassword(e.target.value);
  };
  const handleIdentifiantChange = (e) => {
    setSelectedIdentifiant(e.target.value);
  };

  const handleBuilderChange = (e) => {
    setSelectedBuilder(e.target.value);
  };

  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderYesNoOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedActif === null ||
      selectedRole === null ||
      selectedPrenom === "" ||
      selectedNom === "" ||
      selectedEmail === ""
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_users/${id}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              fx_users: {
                id: id,
                first_name: selectedPrenom,
                last_name: selectedNom,
                email: selectedEmail,

                password: selectedPassword,
                fx_role_id: selectedRole?.value || "",
                builder: selectedBuilder,
                active: selectedActif?.value || selectedActif ? 1 : 2,
                partenaire_id:
                  selectedPartenaire?.map((item) => item.value) || "",
                investisseur_id: selectedInvestisseur?.value || "",
              },
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          handleNavigate();
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (responseData && responseData.fx_user_validation) {
            const errors = responseData?.fx_user_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (!loading) {
      getRole();
      getInvestisseurs();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      getPartenaires();
    }
  }, [loading, selectedRole]);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Utilisateurs | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails Utilisateur
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/fx_users/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Utilisateurs
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          userData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                {userData?.detail_fx_user?.Identification ? (
                                  <Card className="mb-4">
                                    <CardTitle
                                      tag="h5"
                                      style={{ paddingLeft: "10px" }}
                                    >
                                      {" "}
                                      Identification
                                    </CardTitle>
                                    <CardBody>
                                      {Object.entries(
                                        userData?.detail_fx_user?.Identification
                                      ).map(([key, value], index) => (
                                        <Row className="mb-2" key={index}>
                                          {key === "Prénom" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  type="text"
                                                  defaultValue={selectedPrenom}
                                                  onChange={handlePrenomChange}
                                                />
                                                {selectedPrenom === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Prénom ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Nom" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  type="text"
                                                  defaultValue={selectedNom}
                                                  onChange={handleNomChange}
                                                />
                                                {selectedNom === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Nom ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Email" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  type="text"
                                                  defaultValue={selectedEmail}
                                                  onChange={handleEmailChange}
                                                />
                                                {selectedEmail === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Email ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Identifiant" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  type="text"
                                                  defaultValue={
                                                    selectedIdentifiant
                                                  }
                                                  disabled
                                                />
                                                {selectedIdentifiant === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Identifiant ne peut pas être
                                                    vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : null}
                                        </Row>
                                      ))}
                                      <Row>
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i style={{ color: "#9d9c9c" }}>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "11em",
                                                paddingTop: "10px",
                                              }}
                                            >
                                              Mot de passe :
                                            </span>
                                          </i>
                                        </Col>
                                        <Col className="col-md-6">
                                          <input
                                            className="form-control form-control-sm"
                                            type="password"
                                            defaultValue={selectedPassword}
                                            onChange={handlePasswordChange}
                                          />
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                ) : null}
                              </Col>
                              <Col sm="6">
                                {userData?.detail_fx_user?.["Droits"] ? (
                                  <Card className="mb-4">
                                    <CardTitle
                                      tag="h5"
                                      style={{ paddingLeft: "10px" }}
                                    >
                                      {" "}
                                      Droits
                                    </CardTitle>
                                    <CardBody>
                                      {Object.entries(
                                        userData?.detail_fx_user?.["Droits"]
                                      ).map(([key, value], index) => (
                                        <Row className="mb-2" key={index}>
                                          {key === "Actif" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Switch
                                                  uncheckedIcon={<Offsymbol />}
                                                  checkedIcon={<OnSymbol />}
                                                  onColor="#555B21"
                                                  onChange={() => {
                                                    setSelectedActif(
                                                      !selectedActif
                                                    );
                                                  }}
                                                  checked={
                                                    selectedActif?.value == 1
                                                      ? true
                                                      : selectedActif == true
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                {selectedActif === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Actif ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Rôle" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  defaultValue={
                                                    selectedRole?.label == null
                                                      ? null
                                                      : selectedRole
                                                  }
                                                  onChange={handleRoleChange}
                                                  options={renderRoleOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  styles={styles(
                                                    selectedRole === null
                                                  )}
                                                />
                                                {selectedRole === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Rôle ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Investisseur" &&
                                            (selectedRole?.value == 11 ||
                                              selectedRole?.value == 5) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  defaultValue={
                                                    selectedInvestisseur?.label ==
                                                    null
                                                      ? null
                                                      : selectedInvestisseur
                                                  }
                                                  onChange={
                                                    handleInvestisseurChange
                                                  }
                                                  options={renderInvestisseurOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  styles={styles(
                                                    selectedInvestisseur ===
                                                      null
                                                  )}
                                                />
                                                {selectedInvestisseur ===
                                                null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Investisseur ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Partenaire" &&
                                            (selectedRole?.value == 10 ||
                                              selectedRole?.value == 12 ||
                                              selectedRole?.value == 6) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  defaultValue={
                                                    selectedPartenaire
                                                  }
                                                  onChange={
                                                    handlePartenaireChange
                                                  }
                                                  options={renderPartenaireOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  isMulti
                                                  styles={styles(
                                                    selectedPartenaire === null
                                                  )}
                                                />
                                                {selectedPartenaire === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Partenaire ne peut pas être
                                                    vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Builder" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={selectedBuilder}
                                                  required
                                                  onChange={handleBuilderChange}
                                                />
                                              </Col>
                                            </>
                                          ) : null}
                                        </Row>
                                      ))}
                                      {!Object.keys(
                                        userData?.detail_fx_user?.["Droits"]
                                      ).includes("Partenaire") &&
                                      (selectedRole?.value == 10 ||
                                        selectedRole?.value == 12 ||
                                        selectedRole?.value == 6) ? (
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>Partenaire* :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              defaultValue={selectedPartenaire}
                                              isMulti
                                              onChange={handlePartenaireChange}
                                              options={renderPartenaireOptions()}
                                              isClearable={true}
                                              className="select2"
                                              menuPortalTarget={document.body}
                                              styles={styles(
                                                selectedPartenaire === null
                                              )}
                                            />
                                            {selectedPartenaire === null ? (
                                              <div
                                                style={{
                                                  color: "red",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Partenaire ne peut pas être vide
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {!Object.keys(
                                        userData?.detail_fx_user?.["Droits"]
                                      ).includes("Investisseur") &&
                                      (selectedRole?.value == 11 ||
                                        selectedRole?.value == 5) ? (
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>Investisseur* :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              defaultValue={
                                                selectedInvestisseur?.label ==
                                                null
                                                  ? null
                                                  : selectedInvestisseur
                                              }
                                              onChange={
                                                handleInvestisseurChange
                                              }
                                              options={renderInvestisseurOptions()}
                                              isClearable={true}
                                              className="select2"
                                              menuPortalTarget={document.body}
                                              styles={styles(
                                                selectedInvestisseur === null
                                              )}
                                            />
                                            {selectedInvestisseur === null ? (
                                              <div
                                                style={{
                                                  color: "red",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Investisseur ne peut pas être
                                                vide
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </Col>
                                        </Row>
                                      ) : null}
                                    </CardBody>
                                  </Card>
                                ) : null}
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditUser;
